// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"668b47b9","164":"0e75b5d6","329":"b0ba4051"}[chunkId] + ".chunk.js";
};